import React from 'react';

export function Table({ children, className = '' }) {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-800">
        {children}
      </table>
    </div>
  );
}

export function TableHeader({ children, className = '' }) {
  return (
    <thead className={`bg-gray-50 dark:bg-gray-900 ${className}`}>
      {children}
    </thead>
  );
}

export function TableBody({ children, className = '' }) {
  return (
    <tbody className={`bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-800 ${className}`}>
      {children}
    </tbody>
  );
}

export function TableRow({ children, className = '', onClick, highlighted = false }) {
  const highlightStyles = highlighted ? 'bg-yellow-50 dark:bg-yellow-900/30' : '';
  const hoverStyles = onClick ? 'hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer' : '';

  return (
    <tr
      className={`${highlightStyles} ${hoverStyles} ${className}`}
      onClick={onClick}
    >
      {children}
    </tr>
  );
}

export function TableHead({ children, className = '', align = 'left' }) {
  const alignClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  return (
    <th
      scope="col"
      className={`px-3 sm:px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider ${alignClass} ${className}`}
    >
      {children}
    </th>
  );
}

export function TableCell({ children, className = '', align = 'left' }) {
  const alignClass = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';

  return (
    <td className={`px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm ${alignClass} ${className}`}>
      {children}
    </td>
  );
}

export default Table;
